import { useEffect, useState } from "react";
import NavV2 from "../components/v2/NavV2";
import HeroV2 from "../components/v2/HeroV2";
import ManifestoV2 from "../components/v2/ManifestoV2";
import ProjectsCinematic from "../components/v2/ProjectsCinematic";
import LiveProgressV2 from "../components/v2/LiveProgressV2";
import MarqueeV2 from "../components/v2/MarqueeV2";
import ContactV2 from "../components/v2/ContactV2";
import FooterV2 from "../components/v2/FooterV2";
import { api } from "../lib/api";

export default function HomeV2() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    document.body.classList.add("v2-body");
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => {});
    return () => {
      document.body.classList.remove("v2-body");
    };
  }, []);

  return (
    <div data-testid="home-v2-root" className="bg-charcoal text-charcoal_ink min-h-screen">
      <NavV2 />
      <main id="top-v2">
        <HeroV2 />
        <ManifestoV2 />
        <ProjectsCinematic projects={projects} />
        <LiveProgressV2 projects={projects} />
        <MarqueeV2 />
        <ContactV2 />
      </main>
      <FooterV2 />
    </div>
  );
}
